import { Injectable } from '@angular/core';
import { Message } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class MessageService {
	public readonly currentSticky = new BehaviorSubject<Message[]>([]);
	public readonly currentShort = new BehaviorSubject<Message[]>([]);

	createMessage(msg: Message, sticky: boolean = false) {
		if (msg != null) {
			if (sticky) {
				this.currentSticky.next([msg]);
			} else {
				this.currentShort.next([msg]);
			}
		}
	}
	clearSticky() {
		this.currentSticky.next([]);
	}
}
